// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { StreamVideoCommandParams, IStreamVideoCommandParams } from "./DeviceCommands.StreamVideoCommandParams.gen";
import { Device, IDevice } from "./Device.gen";

export interface IStreamVideoCommand {
	description: string | undefined;

	commandParamsJson: IStreamVideoCommandParams | undefined;

	device: IDevice | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	dateCreated: string | undefined;

	dateSentToDevice: string | undefined;

	dateCompleted: string | undefined;

	deviceDidSucceed: boolean | undefined;

	deviceResponse: string | undefined;

	$type?: string | undefined;
}
export class StreamVideoCommand {
	constructor(data?: IStreamVideoCommand) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.commandParamsJson) { this.commandParamsJson = new StreamVideoCommandParams(data.commandParamsJson); }
		if (data.device) { this.device = new Device(data.device); }
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		if (data.dateSentToDevice) { this.dateSentToDevice = new Date(data.dateSentToDevice); }
		if (data.dateCompleted) { this.dateCompleted = new Date(data.dateCompleted); }
	}

	description: string | undefined;

	commandParamsJson: StreamVideoCommandParams | undefined;

	device: Device | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	dateCreated: Date | undefined = new Date();

	dateSentToDevice: Date | undefined;

	dateCompleted: Date | undefined;

	deviceDidSucceed: boolean | undefined;

	deviceResponse: string | undefined;

	static $type: string = "CoreApi.Models.DeviceCommands.StreamVideoCommand, ";
	$type?: string | undefined = StreamVideoCommand.$type;
}

